import { EntityDescriptor } from '../business-logic';
import {
	capacityCheckJSONSchema,
	ICapacityCheckDocType,
} from '../schemas/capacityCheck';

export const capacityCheckEntity: EntityDescriptor<
	ICapacityCheckDocType<'ANY'>
> = {
	capacityCheck: {
		schema: capacityCheckJSONSchema,
		migrationStrategies: {
			1: function (oldDoc: any) {
				return oldDoc;
			},
			2: function (oldDoc: any) {
				return oldDoc;
			},
		},
	},
};
